import "@/components/Charts/charts.scss";
import ReportChips from "kinnect-general/reports/ReportChips";
import ReportFilters from "kinnect-general/reports/ReportFilters";
import ReportHeader from "kinnect-general/reports/ReportHeader";
import { FetchesData, Reportable } from "kinnect-mixins";
import { KDatePicker } from "kinnect-general";
import { OutboundFreightReport } from "kinnect-models";
import { VCard, VCardText } from "vuetify/lib";

export default {
	name: "OutboundFreightReport",

	mixins: [
		FetchesData,
		Reportable
	],

	data: () => ( {
		outboundFreightReport: []
	} ),

	methods: {
		async fetchReport() {
			this.outboundFreightReport = await OutboundFreightReport.params( {
				startDate: this.startDate,
				endDate: this.endDate
			} ).get();
		},

		async fetch() {
			await this.fetchReport();
		}
	},

	render() {
		return <VCard loading={this.$wait.is( "get outbound freight reports" ) ? "link" : false}>
			<ReportHeader>
				<ReportFilters
					filters={[
						{
							key: "startDate",
							value: this.startDate
						},
						{
							key: "endDate",
							value: this.endDate
						}
					]}
					onSave={props => {
						this.startDate = props.startDate;
						this.endDate = props.endDate;
						this.fetchReport();
					}}
					scopedSlots={{
						"filter.startDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "Start Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>,

						"filter.endDate": props =>
							<KDatePicker
								textFieldProps={{
									label: "End Date*",
									required: true
								}}
								vModel={props.model}
							></KDatePicker>
					}}
				></ReportFilters>

				<ReportChips
					cols={12}
					sm="auto"
					filters={[
						{
							name: "Start Date",
							value: this.startDate
						},
						{
							name: "End Date",
							value: this.endDate
						}
					]}
				></ReportChips>
			</ReportHeader>

			<VCardText></VCardText>
		</VCard>;
	}
};
